import { connect } from 'react-redux';
import { CardBg, CardImage } from '@fttb/common/components';
import { getTariffBgColor, getTariffImageSrc, getTariffImageWidth } from "../../../../store/blocks/tariffs/tariffSelectors";
export var TariffImage = connect(function (state) {
  return {
    src: getTariffImageSrc(state)
  };
})(CardImage);
export var TariffBg = connect(function (state) {
  return {
    background: getTariffBgColor(state),
    width: getTariffImageWidth(state)
  };
})(CardBg);